import React from 'react';
import { connect, useDispatch } from 'react-redux';
import './contactus.scss';
import Icon from '@mdi/react';
import { mdiArrowLeft, mdiLoading, mdiAt, mdiClose } from '@mdi/js';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from "react-hook-form";
import { useEffect, useState, useCallback } from "react";
import { CONTACT_LOAD, CONTACT_UNLOAD, CONTACT_FORMSUBMIT } from '../../constants/actionTypes';
import agent from '../../agent';
import { Helmet } from "react-helmet";
import Modal from 'react-modal';
import Footer from '../../components/Footer/Footer';
//import CustomFunction from '../../components/customFuction';

const mapStateToProps = state => ({ ...state, supportinfo: state });

const mapDispatchToProps = dispatch => ({
  // onContactData: (payload) =>
  //   dispatch({ type: CONTACT_LOAD, payload}),
  onContactUnload: () =>
    dispatch({ type: CONTACT_UNLOAD }),
});

const ContactUs = (props) => {
  // Set States
  //console.log("props",props?.common?.currentUser?.results );
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoading, setLoading] = useState(true)
  const [isSubmitButtonLoading, setSubmitButtonLoading] = useState(false)
  const [successModalIsOpen, setSuccessModelIsOpen] = useState(false);
  const [cardAddPopup, setCardAddPopup] = React.useState(true);
 // console.log("location", location);
  const navigate = useNavigate();
  // Load Contact Info Like(mobile and Email)
  const loadDataOnlyOnce = useCallback(() => {
    return dispatch({ type: CONTACT_LOAD, payload: agent.Contactus.supportinfo() })
  }, [dispatch]);

  // form validation rules 
  const validationSchema = Yup.object().shape({
    orderid: Yup.string().required('Order ID is required.').min(2).max(64),
    message: Yup.string().required('Message is required.').min(2).max(256),
  });
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: {
      orderid: location?.state?.ref_id,
      message: '',
    }
  };
  const userid = location?.state?.customer?._id;
  const refid = location?.state?.ref_id;
  const emailid = location?.state?.customer?.email;
  const order_id = location?.state?._id;
 // console.log("USER-ID", userid);
  //setValue('orderid',location?.state?._id)
  // get functions to build form with useForm() hook
  const { register, handleSubmit, formState, reset, setValue } = useForm(formOptions);
  const { errors } = formState;

  // After Form Submit Error Message
  let contactError = '';
  if (props.contactus) {
    if (props.contactus.errors) {
      contactError = props.contactus.errors
    }
  }

  // After Form Submit FormField Error Message
  let contactMulError = [];
  if (props.contactus.contactForm) {
    if (props.contactus.contactForm.code === 422) {
      contactMulError = props.contactus.contactForm
      //contactMulError = CustomFunction.isErrorMulFormMessage(contactMulError.errors.json.message)
    }
  }


  // After Form Submit Success Message
  let contactSuccess = '';
  if (props.contactus) {
    if (props.contactus.data) {
      contactSuccess = props.contactus.data
    }
  }

  const customStyles = {
    content: {
      top: '40%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      maxWidth: '400px',
      padding: '30px 15px',
      width: '90%'
    },
  };
  

  // Form Submit
  function onSubmit(data) {
    setSubmitButtonLoading(true)
    setTimeout(() => {
      setSubmitButtonLoading(false)
    }, 500);

    const payload = {
      email: emailid ? emailid : props?.common?.currentUser?.results?.email,
      message: data.message,
      ref_id: refid ? refid : data.orderid,
      role: "user",
      user: userid ? userid : props?.common?.currentUser?.results?._id
  };
  //  const user = data?.state?.ref_id
  //  console.log("user-id", user);
  agent.Contactus.supportform(payload)
    .then(response => {
      setSubmitButtonLoading(false); // Set loading state to false

      if (response?.message === "CREATED") {
        // Open your popup here
        // console.log("Popup opened");
        setSuccessModelIsOpen(true);
      }

      // Assuming you want to navigate regardless of whether the popup opens
      // navigate('/order-history');
    })
    .catch(error => {
      setSubmitButtonLoading(false); // Set loading state to false in case of an error
      // console.error("Error submitting form:", error);
      setSuccessModelIsOpen(false)
    });
  }
  
  function handleCloseModel() {
    setSuccessModelIsOpen(false);
  }

  const handleBackClick = () => {
    console.log("Handle Back Click triggered");
    if (location?.state?.From === 'profile') {
      console.log("Navigating back to profile");
      navigate('/profile' +location.pathname);
    }
  };


  useEffect(() => {
    // Call contact information
    //loadDataOnlyOnce(); // this will fire only on first render
    dispatch({ type: CONTACT_UNLOAD })
    setTimeout(() => {
      setLoading(false)
    }, 1000);
  }, [dispatch, loadDataOnlyOnce]);

  // let supportinfoMob = '';
  let supportinfoEmail = '';
  if (props.contactus.contact) {
    // supportinfoMob = props.contactus.contact[0].contact_number;
    supportinfoEmail = props.contactus.contact[0].contact_email;
  }

  const contactBackground = require('./Background.png');
  return isLoading ? (   //Checkif if is loading
    <div className="lds-ripple"><div></div><div></div></div>
  ) : (
    <>
      <div className='contactus_bg'>
        <div className='main'
        >
          <Helmet>
            <title>RideDoc | Contact Us</title>
            <meta name="description" content="Mobile bike mechanics at your door step" />
          </Helmet>
          <div className='header-wrp'>
            <header>
              <div className="header-backic">
                <Link onClick={() => window.history.back()} className="header-backic-icon">
                  <Icon path={mdiArrowLeft} size={'28px'} color="#222" />
                </Link>
              </div>
              <div className='contact-header-text'>
                <p>Contact Us</p>
              </div>
            </header>
          </div>
          <div className='main-wrapper'>
            <div className="contactus-wrp booking-wrp">
              <section className="contactus-in">
                <div className="contactus-form-wrp">
                  <div className="contactus-form-hd">
                    <h1>Get In Touch</h1>
                    <h3>Our team will get back to you
                      within 24 hours.</h3>
                  </div>
                  <div className="contactus-form-in">
                    {contactError && <span className='error'>{contactError}</span>}
                    {contactMulError && contactMulError}
                    {contactSuccess && <span className='success'>{contactSuccess}</span>}
                    <form onSubmit={handleSubmit(onSubmit)} className='contactus-form'>
                      <div className="form-group-wrp">
                        <div className="form-group">
                          <input className="form-control" type="text" {...register('orderid')} name="orderid" id="orderid" />
                          <label className="form-lbl lbl-orderid" style={{top: 15}} htmlFor="orderid">Order No</label>
                        </div>
                        {errors.orderid &&
                          <div className="invalid-feedback">{errors.orderid?.orderid}</div>
                        }
                        <div className="form-group">
                          <textarea className="form-control form-control-textarea contact-us-textarea" {...register('message')} name="message" id="message"></textarea>
                          <label className="form-lbl lbl-message" style={{bottom: "0px"}} htmlFor="message">Message</label>
                        </div>
                        {errors.message &&
                          <div className="invalid-feedback">{errors.message?.message}</div>
                        }
                      </div>
                      <div className="form-group">

                        <button className="btn btn-primary btn-contact-us">{isSubmitButtonLoading ? <Icon path={mdiLoading} size={'28px'} color="#fff" spin={0.5} /> : "Send Message"}</button>
                      </div>
                    </form>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <Footer />
      </div>


      <Modal
        isOpen={successModalIsOpen}
        onRequestClose={handleCloseModel}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
        style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="Example Modal"
        >

          <div className='booking-wrp'>
          <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                <div className='reg-close' onClick={handleCloseModel}>
                  <Icon path={mdiClose} size={'24px'} color="#222" />
                </div>
              </div>
            </div>
            <div className="rd-popup-content order-slot-cnt">
              <p className='zipcode-popup-mssage'>Message sent successfully</p>
            </div>
          </div>
        </div>

        <div className='ok-button' style={{ width: "4.5rem", margin: "0 auto" }}>
          <button className="btn btn-primary btn-update-ok" onClick={() => window.history.back()}> OK </button>
        </div>

        </Modal>
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);